import { useLocale } from "@/hooks/useLocale";
import { SeriousAboutTalent } from "@/ui/SeriousAboutTalent";
import Image from "@/ui/Image";
import { Col } from "react-bootstrap";
import { stripTags } from "@/functions/stripTags";
import YoutubeVideoModal from "@/ui/YoutubeVideoModal";
import { getGlobal } from "@/functions/getGlobal";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import React from "react";

export const SpecialismPageContentSection = ({ className, item, title }) => {
  const pathPrefix = `page.specialism.${item.url_slug}.content`;
  const global = getGlobal();
  const locale = useLocale();

  return (
    <SeriousAboutTalent
      className={className}
      tag={`page.specialism.content.tag.${locale}`}
      title={title ?? `${pathPrefix}.title.${locale}`}
      text={`${pathPrefix}.text.${locale}`}
      details={`${pathPrefix}.details.${locale}`}
    >
      <Col xs={12} lg={6}>
        {/* START: CMS Tools editable fix */}
        <SourceFlowText
          global={global}
          path={`${pathPrefix}.video.${locale}`}
          type="text"
          className="visually-hidden"
        />
        {/* END: CMS Tools editable fix */}
        <YoutubeVideoModal video_embed_url={stripTags(global[`${pathPrefix}.video.${locale}`]).trim()}>
          <div className="ratio ratio-4x3 mt-4">
            <Image
              img={{
                path: `${pathPrefix}.image`,
                src: "/assets/specialisms/content/1.jpg",
              }}
              size="622x"
              alt=""
              style={{ objectFit: "cover", objectPosition: "center right" }}
            />
          </div>
        </YoutubeVideoModal>
      </Col>
    </SeriousAboutTalent>
  );
};
